import { useState } from 'react';
import QuizApp from './components/QuizApp';
import Leaderboard from './components/Leaderboard';
import AdminWrapper from './components/AdminWrapper';
import LandingPage from './components/LandingPage';

function App() {
  const [path] = useState(window.location.pathname);

  // Handle root path - show landing page
  if (path === '/') {
    return <LandingPage />;
  }

  // Handle /admin route
  if (path === '/admin') {
    return <AdminWrapper />;
  }

  // Handle /{quizId}/leaderboard route
  const leaderboardMatch = path.match(/^\/([^/]+)\/leaderboard$/);
  if (leaderboardMatch) {
    const quizId = leaderboardMatch[1];
    return <Leaderboard quizId={quizId} />;
  }

  // Handle /{quizId} route
  const quizMatch = path.match(/^\/([^/]+)$/);
  if (quizMatch) {
    const quizId = quizMatch[1];
    return <QuizApp quizId={quizId} />;
  }

  // Default fallback - show landing page
  return <LandingPage />;
}

export default App;
